import React,{useState} from "react";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import Modal from '@mui/material/Modal';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import { Select, MenuItem, Checkbox, ListItemText, FormControl, ListSubheader } from '@mui/material';
import Button from '@mui/material/Button';
import TextField from "@mui/material/TextField";
import axios from "axios";
import {getUserMaintenanceList} from "../function-components/Redux/ProjectMasterSlice";
import { useDispatch, useSelector } from "react-redux";

const baseURL = "https://atcilkm.listracker.accenture.com/listracker-apis";
//const baseURL = "http://localhost:1101";

const AddNewMemberModal = () => {
const theme = createTheme({
    typography: {
    fontFamily: "Graphik-Regular",
    },
    });
const [open, setOpen] = useState(false);
const handleOpen = () => setOpen(true);
const handleClose = () => setOpen(false); 
const [team, setTeam] = useState('select');
const [action, setAction] = useState('select');
const [username, setUsername] = useState('');
const [addProjectResult, setAddProjectResult] = useState(''); 
const UserMaintenanceData = useSelector((state) => state.projectMaster.userMaintenanceList); 
const dispatch = useDispatch();

function handleAddMember() {
  if (username === '' || team === 'select' || action === 'select') {
    setAddProjectResult('invalidate');
    setTimeout(() => {
      setAddProjectResult('');
    }, 3000)
    return;
  }
  if (isDuplicateMember(username)) {
        setAddProjectResult('duplicate');
        setTimeout(() => {
          setAddProjectResult('');
        }, 3000);
        return;
      }
  axios.post(`${baseURL}/addNewMember`,{
    "username": username,
    "team": team,
    "action": action,
    "status":"Available"
  })
  .then(res => {
    console.log(res);
    setAddProjectResult(res.statusText);
    dispatch(getUserMaintenanceList());
    setTimeout(() => {
      setAddProjectResult('');
    }, 3000)
    handleResetMember();
  })
  .catch(err => {
    setAddProjectResult("Failed to add member!")
    setTimeout(() => {
      setAddProjectResult('');
    }, 3000)
  })
}


function handleResetMember(){
  setUsername('');
  setTeam('select');
  setAction('select');
}


function isDuplicateMember(newName) {
  return UserMaintenanceData.some((list) => list.username === newName);
}

    return (
        <>
         <ThemeProvider theme={theme}>
         <Typography sx={{fontWeight:"bold !important"}} onClick={handleOpen}>+ Add New Member</Typography>
         <Modal open={open} onClose={handleClose} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
         <Box className="popUp-wrapper1">
          <div className="modalHeader">
              <h3 className="modalHeading">Add New Member</h3>
              <span className="close_btn_model" onClick={handleClose}>X</span>
          </div>
          <div id="addProject">
            <div className="inputField-row-addmember">
            <FormControl variant="standard" style={{width:"40%"}}>
              <label>Enter Enterprise Id<span className="add-project--asterisk">*</span></label>
              <TextField
                variant="outlined"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
              >
                </TextField>
              </FormControl> 
            <FormControl variant="standard" style={{width:"30%"}}>  
            <label>Select Team<span className="add-project--asterisk">*</span></label>              
            <TextField   
            variant="outlined"
            select
            value={team}
            onChange={(e) => setTeam(e.target.value)}
            >         
            <MenuItem key={1} value='select'>
                    Select . . .
                  </MenuItem>
                  <MenuItem key={2} value="Design">
                    Design
                  </MenuItem>
                  <MenuItem key={3} value="Development">
                    Development
                  </MenuItem>                  
                  <MenuItem key={4} value="PowerBI">
                    Power BI
                  </MenuItem>
                </TextField>
                </FormControl>
            <FormControl variant="standard" style={{width:"30%"}}>  
            <label>Select Status<span className="add-project--asterisk">*</span></label>              
            <TextField   
            variant="outlined"    
            select 
            value={action}
            onChange={(e) => setAction(e.target.value)}
            >      
             <MenuItem key={1} value='select'>
                    Select . . .
                  </MenuItem>
                  <MenuItem key={2} value="Active">
                    Active
                  </MenuItem>
                  <MenuItem key={3} value="Inactive">
                    Inactive
                  </MenuItem>                     
                </TextField>
                </FormControl>
            </div>
            <div className="buttonRow">
              <Button className="addBtn" onClick={handleAddMember}>Add</Button>
              <Button className="resetBtn" onClick={handleResetMember}>Reset</Button>
              {addProjectResult === 'OK' && <span className="add-project--success">Member added Successfully.</span>}
              {addProjectResult === 'failed' && <span className="add-project--failed">Failed to add member!</span>}
              {addProjectResult === 'invalidate' && <span className="add-project--invalidate">All fields marked with an asterisk (*) are required.</span>}
              {addProjectResult === 'duplicate' && <span className="add-project--invalidate">Enterprise Id already exist.</span>}             
              </div>
          </div>
          </Box>
         </Modal>
         </ThemeProvider>
        </>
    )
}

export default AddNewMemberModal;